module.exports = __webpack_public_path__ + "static/media/trashbin_green_light.a564dd68.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/trashbin_green_light.svg
// module id = 136
// module chunks = 0